import {Component, Vue} from "vue-property-decorator";
import {DebtCustomer} from "@/interfaces/entity";
import {ClearingDebtType} from "@/enums/type";

@Component({
    name: "DebtCustomerMixin"
})
export default class extends Vue {

    clearingMoneyDebtCustomer(debt: DebtCustomer) {
        let clearingMoney = debt.clearingMoney || 0;
        if (debt.clearingType === ClearingDebtType.No) clearingMoney = 0;
        return clearingMoney;
    }

    calculateSenderPayDebtCustomer(debt: DebtCustomer) {
        const clearingMoney = this.clearingMoneyDebtCustomer(debt);
        return debt.money - clearingMoney;
    }

    totalSenderPayDebtCustomer(debts: Array<DebtCustomer>) {
        return debts.reduce((previousValue, currentValue) => {
            const senderPay = this.calculateSenderPayDebtCustomer(currentValue);
            return previousValue + senderPay;
        }, 0);
    }

    totalClearingMoneyDebtCustomer(debts: Array<DebtCustomer>) {
        return debts.reduce((previousValue, currentValue) => {
            const clearingMoney = this.clearingMoneyDebtCustomer(currentValue);
            return previousValue + clearingMoney;
        }, 0);
    }

    totalCodMoneyDebtCustomer(debts: Array<DebtCustomer>) {
        return debts.reduce((previousValue, currentValue) => {
            return previousValue + currentValue.money;
        }, 0);
    }
}